import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_5e63f9d2 from 'nuxt_plugin_plugin_5e63f9d2' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_74c8c91e from 'nuxt_plugin_sentryserver_74c8c91e' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_5fe229e9 from 'nuxt_plugin_sentryclient_5fe229e9' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_54baf037 from 'nuxt_plugin_plugin_54baf037' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_plugin_67938ebf from 'nuxt_plugin_plugin_67938ebf' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_67510356 from 'nuxt_plugin_cookieuniversalnuxt_67510356' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_toast_1173255c from 'nuxt_plugin_toast_1173255c' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_4542d8ad from 'nuxt_plugin_axios_4542d8ad' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginsblackburncomponents2ef28b69_2cb6d74c from 'nuxt_plugin_pluginsblackburncomponents2ef28b69_2cb6d74c' // Source: ./plugins.blackburn-components.2ef28b69.js (mode: 'all')
import nuxt_plugin_vuexpersistedstate_072cbbd4 from 'nuxt_plugin_vuexpersistedstate_072cbbd4' // Source: ../../../plugins/vuex-persistedstate.js (mode: 'all')
import nuxt_plugin_chatbotcore_3be7cb64 from 'nuxt_plugin_chatbotcore_3be7cb64' // Source: ../../../plugins/chatbot-core.js (mode: 'all')
import nuxt_plugin_vuelidate_4be431c8 from 'nuxt_plugin_vuelidate_4be431c8' // Source: ../../../plugins/vuelidate.js (mode: 'all')
import nuxt_plugin_vueinputautowidth_0983ece0 from 'nuxt_plugin_vueinputautowidth_0983ece0' // Source: ../../../plugins/vue-input-autowidth.js (mode: 'all')
import nuxt_plugin_textareaautosize_2e5c042a from 'nuxt_plugin_textareaautosize_2e5c042a' // Source: ../../../plugins/textarea-autosize.js (mode: 'all')
import nuxt_plugin_amplifyapi_1e20d3ac from 'nuxt_plugin_amplifyapi_1e20d3ac' // Source: ../../../plugins/amplify-api.js (mode: 'all')
import nuxt_plugin_notification_0f206214 from 'nuxt_plugin_notification_0f206214' // Source: ../../../plugins/notification.js (mode: 'all')
import nuxt_plugin_realtime_2288cf76 from 'nuxt_plugin_realtime_2288cf76' // Source: ../../../plugins/realtime.js (mode: 'all')
import nuxt_plugin_directives_521c0486 from 'nuxt_plugin_directives_521c0486' // Source: ../../../plugins/directives.js (mode: 'all')
import nuxt_plugin_vuequilleditor_4665c1b6 from 'nuxt_plugin_vuequilleditor_4665c1b6' // Source: ../../../plugins/vue-quill-editor.js (mode: 'all')
import nuxt_plugin_quill_19b7edf2 from 'nuxt_plugin_quill_19b7edf2' // Source: ../../../assets/styles/quill.css (mode: 'all')
import nuxt_plugin_x6_331c2e7a from 'nuxt_plugin_x6_331c2e7a' // Source: ../../../plugins/x6.js (mode: 'all')
import nuxt_plugin_navigator_286c76b6 from 'nuxt_plugin_navigator_286c76b6' // Source: ../../../plugins/navigator.js (mode: 'all')
import nuxt_plugin_codemirror_1be7a2d5 from 'nuxt_plugin_codemirror_1be7a2d5' // Source: ../../../plugins/codemirror.js (mode: 'all')
import nuxt_plugin_elementui_72a9ed1c from 'nuxt_plugin_elementui_72a9ed1c' // Source: ../../../plugins/element-ui.js (mode: 'all')
import nuxt_plugin_auth_1ebc86e3 from 'nuxt_plugin_auth_1ebc86e3' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_meta_0a3e0d91 from 'nuxt_plugin_meta_0a3e0d91' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"Amplify %s","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fres.cloudinary.com\u002Fact-amp\u002Fimage\u002Fupload\u002Fv1677685287\u002Fassets\u002Ffavicon_fznenm.png"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossOrigin":true},{"rel":"stylesheet","href":"https:\u002F\u002Fd1azc1qln24ryf.cloudfront.net\u002F214395\u002FBlackburn\u002Fstyle.css?ai2fyf"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_5e63f9d2 === 'function') {
    await nuxt_plugin_plugin_5e63f9d2(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_74c8c91e === 'function') {
    await nuxt_plugin_sentryserver_74c8c91e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_5fe229e9 === 'function') {
    await nuxt_plugin_sentryclient_5fe229e9(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_54baf037 === 'function') {
    await nuxt_plugin_plugin_54baf037(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_67938ebf === 'function') {
    await nuxt_plugin_plugin_67938ebf(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_67510356 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_67510356(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_1173255c === 'function') {
    await nuxt_plugin_toast_1173255c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4542d8ad === 'function') {
    await nuxt_plugin_axios_4542d8ad(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsblackburncomponents2ef28b69_2cb6d74c === 'function') {
    await nuxt_plugin_pluginsblackburncomponents2ef28b69_2cb6d74c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexpersistedstate_072cbbd4 === 'function') {
    await nuxt_plugin_vuexpersistedstate_072cbbd4(app.context, inject)
  }

  if (typeof nuxt_plugin_chatbotcore_3be7cb64 === 'function') {
    await nuxt_plugin_chatbotcore_3be7cb64(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4be431c8 === 'function') {
    await nuxt_plugin_vuelidate_4be431c8(app.context, inject)
  }

  if (typeof nuxt_plugin_vueinputautowidth_0983ece0 === 'function') {
    await nuxt_plugin_vueinputautowidth_0983ece0(app.context, inject)
  }

  if (typeof nuxt_plugin_textareaautosize_2e5c042a === 'function') {
    await nuxt_plugin_textareaautosize_2e5c042a(app.context, inject)
  }

  if (typeof nuxt_plugin_amplifyapi_1e20d3ac === 'function') {
    await nuxt_plugin_amplifyapi_1e20d3ac(app.context, inject)
  }

  if (typeof nuxt_plugin_notification_0f206214 === 'function') {
    await nuxt_plugin_notification_0f206214(app.context, inject)
  }

  if (typeof nuxt_plugin_realtime_2288cf76 === 'function') {
    await nuxt_plugin_realtime_2288cf76(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_521c0486 === 'function') {
    await nuxt_plugin_directives_521c0486(app.context, inject)
  }

  if (typeof nuxt_plugin_vuequilleditor_4665c1b6 === 'function') {
    await nuxt_plugin_vuequilleditor_4665c1b6(app.context, inject)
  }

  if (typeof nuxt_plugin_quill_19b7edf2 === 'function') {
    await nuxt_plugin_quill_19b7edf2(app.context, inject)
  }

  if (typeof nuxt_plugin_x6_331c2e7a === 'function') {
    await nuxt_plugin_x6_331c2e7a(app.context, inject)
  }

  if (typeof nuxt_plugin_navigator_286c76b6 === 'function') {
    await nuxt_plugin_navigator_286c76b6(app.context, inject)
  }

  if (typeof nuxt_plugin_codemirror_1be7a2d5 === 'function') {
    await nuxt_plugin_codemirror_1be7a2d5(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_72a9ed1c === 'function') {
    await nuxt_plugin_elementui_72a9ed1c(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_1ebc86e3 === 'function') {
    await nuxt_plugin_auth_1ebc86e3(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_0a3e0d91 === 'function') {
    await nuxt_plugin_meta_0a3e0d91(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
